import type { FC } from "react";
import { colorsPalettes } from "@similarweb/styles";
import { NavBarIcon } from "@similarweb/ui-components";
import {
    PopularActionWrapper,
    Body,
    Image,
    Text,
} from "app/pages/digital-suite/home-page/components/PopularActions/styledPopularAction";
import { AssetsService } from "app/services/AssetsService";

export interface IBasePopularAction {
    imgUrl: string;
    text: string;
}
interface IPopularAction extends IBasePopularAction {
    href: string;
    onClick?: () => void;
}
export const PopularAction: FC<IPopularAction> = ({ imgUrl, text, href, onClick }) => {
    const handleClick = () => {
        onClick?.();
    };

    return (
        <PopularActionWrapper
            data-automation={"popular-action"}
            href={href}
            onClick={handleClick}
        >
            <Body>
                <Image src={AssetsService.assetUrl(imgUrl)} />
                <Text data-automation={"popular-action-name"}>{text}</Text>
            </Body>
            <NavBarIcon
                iconSize="sm"
                iconColor={colorsPalettes.blue[400]}
                iconName={"arrow-right"}
            />
        </PopularActionWrapper>
    );
};
